import { Directive, Input, OnChanges, OnDestroy, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { HintTooltipComponent } from '../components/hint-tooltip/hint-tooltip.component';

@Directive({
  selector: '[appHintTooltip]',
})
export class HintTooltipDirective implements OnChanges, OnDestroy {
  @Input() public appHintTooltip: string;

  private componentRef;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (!this.componentRef && this.appHintTooltip) {
      this.viewContainer.clear();
      this.componentRef = this.viewContainer.createComponent(HintTooltipComponent);

      this.componentRef.instance.templateRef = this.templateRef;
      this.componentRef.instance.hint = this.appHintTooltip;
    } else if (this.componentRef && this.appHintTooltip) {
      this.componentRef.instance.hint = this.appHintTooltip;
    } else {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  public ngOnDestroy(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}
